import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import PlanYourVisit from "./sections/PlanYourVisit";
import OurStudioLocation from "./sections/OurStudioLocation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <PlanYourVisit />
      <OurStudioLocation />
      <Footer />
    </div>;
}